import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Spa from './barba/Spa';
import Menu from './components/Menu';
import ScrollToTop from './components/ScrollToTop';
import Scrollocking from './components/Scrolllocking';
import AirDatepicker from 'air-datepicker';
import localeNL from 'air-datepicker/locale/nl';
import 'air-datepicker/air-datepicker.css';
import CtaPopup from "./components/CtaPopup";
import Logo from './components/Logo';

import { gsap } from 'gsap';

export class MuseumSpeelklok {
	constructor() {
		Promise.all([MuseumSpeelklok.domReady()]).then(() => this.init());
	}
	init() {
		new Spa();
		new Scrollocking();
		new Menu();
		new CtaPopup(document.querySelector('[data-cta-popup]'));

		document.addEventListener('bless', (e) => {
			document.querySelectorAll('[data-scroll-to-top]').forEach((el) => new ScrollToTop(el));
			document.querySelectorAll('[data-logo]').forEach((el) => new Logo(el));

		});

		new AirDatepicker('.gform-datepicker', {
			locale: localeNL,
			selectedDates: [new Date()],
			navTitles: {
				days: '<strong>yyyy</strong> <i>MMMM</i>',
				months: 'Select month of <strong>yyyy</strong>',
			},
		});

		// document.dispatchEvent(new Event('bless'));
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new MuseumSpeelklok();
